import { memo } from 'react';
import Box from '@mui/material/Box';
import _map from 'lodash/map';
//Local files
import GridSkeleton from 'components/Common/Feedback/GridSkeleton/GridSkeleton';
import FillDocCard from 'components/FillTemplates/Card/Card';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import { fillTemplatesSelectors } from 'features/fillTemplates';

const FillTemplatesGrid = ({ fetching }) => {
  const { data } = useCustomSelector(fillTemplatesSelectors.getFillTemplatesData);

  if (fetching && !data?.length) return <GridSkeleton />;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '24px 22px', justifyContent: 'center' }}>
      {_map(data, (t) => <FillDocCard key={t?.template?.id} id={t?.id} template={t?.template} />)}
    </Box>
  )
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FillTemplatesGrid {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);